import { yupResolver } from "@hookform/resolvers/yup";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Button, Grid, Tab, Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import {
  BucketAwtENUM,
  EstadosActivacionInstallOTEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  gridSizeMdLg12,
  ROUTER_PATHS,
  useTabsFormOnly,
  useUploadFile,
} from "@/shared";
import {
  OrdenTrabajoQueryKeysEnum,
  SaveOTTecnicoInstallPendingData,
  useFetchUbicacionProductosEnabled,
  useUpdateContrato,
  // useFetchCategoryProduct,
  useUpdateOrdenTrabajo,
} from "@/shared/actions/erp";
import { LoadingButton } from "@mui/lab";
import ConceptosTrasladoSection from "@/erp/orden-servicio/orden-servicio-traslado/components/otros-conceptos-traslado/ConceptosTrasladoSection";
import ExcedenteFibraTraslado from "@/erp/orden-servicio/orden-servicio-traslado/components/otros-conceptos-traslado/ExcedenteFibraTraslado";
import { useExcedenteFibraLive } from "@/erp/orden-servicio/orden-servicio-traslado/components/otros-conceptos-traslado/excedente-fibra.actions";
import {
  excedenteFibraPendiente,
  metrosFibraPlana,
  tieneFibraPlana,
} from "@/erp/orden-servicio/orden-servicio-traslado/components/otros-conceptos-traslado/excedente-fibra.utils";
import { guardarObservacionesTecnico } from "./observaciones-tecnico.actions";
import { calcularHistorialCambiosCoordenadas } from "./instalacion/utils/construirPayloadOrdenTrabajo";
import {
  aprobacionDe,
  cambiaronItems,
  conceptosPendientesAprobacion,
  marcarAprobacionPendiente,
  nombreUsuario,
  trasladoIniciado,
  trazaOtrosConceptos,
  trazaPuntosRed,
} from "@/erp/orden-servicio/orden-servicio-traslado/components/otros-conceptos-traslado/conceptos-traslado.utils";
import type { ConceptoVisita } from "@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/OtrosConceptosVisita";
import type { PuntoRed } from "@/erp/orden-servicio/orden-servicio-visita/components/otros-conceptos/PuntosDeRedVisita";
import {
  CustomButtunsRejectConfirm,
  CustomTabPanel,
  FormTabsOnly,
  SingleIconButton,
  TabsFormBoxScene,
} from "@/shared/components/ui";
import {
  AlertSeverityEnum,
  Contrato,
  // EquiposMaterialesUtilizados,
  MaterialTransferido,
  ONTOption,
  OrdenTrabajo,
} from "@/shared/interfaces";
import {
  a11yProps,
  hasPermission,
  ordenTrabajoSubeTecnicoFormSchema,
  texto,
} from "@/shared/utils";
import { PermissionsEnum } from "@/auth/interfaces";
import {
  useEquiposAdicionales,
  useMaterialesUtilizadosStore,
} from "@/store/erp";
import { useUiConfirmModalStore, useUiStore } from "@/store/ui";
import RejectInstalacionAsigTecModal from "../tables/RejectInstalacionAsigTecModal";
import OTDetalleClienteInstallTecnicoFormTab from "./OTDetalleClienteInstallTecnicoFormTab";
import OTInstalacionTecnicoFormTab from "./OTInstalacionTecnicoFormTab";
import OTMaterialesInstallTecnicoFormTab from "./OTMaterialesInstallTecnicoFormTab";
import { EquiposUtilizadosOTTableType } from "./equipos";
import OTDetalleInstallTecnicoFormTab from "./OTDetalleInstallTecnicoFormTab";
import dayjs from "dayjs";
import { useAuthStore } from "@/store/auth";
import IniciarTrasladoFotosModal from "../tables/fotos/traslado/IniciarTrasladoFotosModal";
import FinalizarTrasladoFotosModal from "../tables/fotos/traslado/FinalizarTrasladoFotosModal";
import FotosTrasladoTab from "../tables/fotos/traslado/FotosTrasladoTab";
import { esOrdenTraslado, fotosProcesoFaltantes, resumenFotosTraslado } from "../tables/fotos/traslado/fotos-traslado.utils";
import {
  FOTOS_TRASLADO_LIVE_KEY,
  useAvisosFotosTraslado,
  useOrdenTrabajoFotosLive,
} from "../tables/fotos/traslado/fotos-traslado.actions";
import {
  CustomAlertCard,
  CardPersonalizado,
} from "@/shared/components/ui/Alerts";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { CategoryProducCodeEnum } from "@/shared/interfaces/erp/inventario";
import { useGeolocation } from "../../hooks";
import { toast } from "react-toastify";

import { useGetProspectoByIdProspecto } from "@/shared/actions/erp";
export interface SaveOrdenTrabajoAsignadaTecProps {
  title: string;
  ordentrabajo: OrdenTrabajo;
  isCorrentingData?: boolean;
}

const SaveOrdenTrabajoAsignadaTec: React.FC<
  SaveOrdenTrabajoAsignadaTecProps
> = ({ title, ordentrabajo, isCorrentingData = false }) => {
  const navigate = useNavigate();
  const returnUrlInstalacionesTecnicoPage =
    ROUTER_PATHS.tecnico.ordenenTrabajoNav;
  ///* hooks -----------------------
  const [optionsONT, setOptionsONT] = useState<ONTOption[]>([]);
  const { handleMethodChange, valueTab, setValueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });
  const { coords, permissionStatus, error, getCurrentCoords } =
    useGeolocation();
  const queryClient = useQueryClient();
  const currentUser = useAuthStore((s) => s.user);
  // ================== EQUIPOS ==================
  // useEquiposDisponiblesFlotaOT({
  //   id: ordentrabajo.id_orden_trabajo,
  //   flota_data: ordentrabajo.flota_data,
  // });
  const clearAllMaterials = useMaterialesUtilizadosStore(
    (s) => s.clearAllMaterials,
  );

  // ================== EQUIPOS --- END ==================
  ///* local state -----------------------
  const [openRejectModal, setOpenRejectModal] = useState(false);
  // --- Flujo de fotos de TRASLADO (solo cuando la OT es un traslado) ---
  const esTraslado = esOrdenTraslado(ordentrabajo);
  // Fotos del traslado EN VIVO (sondeo ligero): si Activaciones elimina una
  // foto, el técnico lo ve sin recargar y las validaciones de finalización
  // usan el estado actual. Solo se superponen los campos de fotos sobre una
  // copia; el `ordentrabajo` que alimenta el formulario no se toca.
  const { ot: otFotosTraslado, snapshot: fotosTrasladoLive } =
    useOrdenTrabajoFotosLive(ordentrabajo, esTraslado);
  useAvisosFotosTraslado(fotosTrasladoLive, esTraslado ? "tecnico" : null);
  // Método de recaudación del traslado (excluyente): lo captura el asesor al crear
  // la orden y viaja en observaciones del agendamiento. Se muestra al técnico en
  // el encabezado (destacado si es "Recaudación técnico": debe cobrar en sitio).
  const _obsTraslado: any =
    (ordentrabajo as any)?.observaciones ||
    (ordentrabajo as any)?.agendamiento_data?.observaciones ||
    {};
  // Valor en dinero a recaudar (viaja en observaciones desde la creación).
  const _valorTraslado = _obsTraslado?.valor_traslado;
  const valorTrasladoFmt =
    _valorTraslado != null && `${_valorTraslado}`.trim() !== ""
      ? `$${_valorTraslado}`
      : null;
  const esRecaudacionTecnico = !!_obsTraslado?.recaudacion_tecnico;
  const metodoRecaudacionTraslado = esRecaudacionTecnico
    ? (valorTrasladoFmt
        ? `Recaudación técnico — Valor a recaudar: ${valorTrasladoFmt}`
        : "Recaudación técnico")
    : _obsTraslado?.cargo_a_factura
    ? "Cargo a factura"
    : null;
  const [openIniciarTraslado, setOpenIniciarTraslado] = useState(false);
  const [iniciarLocationTraslado, setIniciarLocationTraslado] = useState<{ lat: number; lng: number } | null>(null);
  const [openFinalizarTraslado, setOpenFinalizarTraslado] = useState(false);
  // Traslados: 3 pasos de fotos — inicio (6 fotos), proceso (Foto punto inicial +
  // Foto punto final, obligatorias para finalizar) y finalización (6 fotos).
  const [shrink] = useState(true);

  // --- Otros conceptos + puntos de red del TRASLADO (solo esTraslado) ---
  // El técnico puede agregar/cambiar conceptos (catálogo de traslados) y elegir
  // la serie entregada; se persisten en el agendamiento. Si el traslado YA está
  // iniciado, cualquier cambio queda PENDIENTE de aprobación por Activaciones y
  // bloquea la finalización hasta que lo aprueben. No toca instalaciones.
  const _obsAgTraslado: any =
    (ordentrabajo as any)?.agendamiento_data?.observaciones || {};
  const [conceptosTraslado, setConceptosTraslado] = useState<ConceptoVisita[]>([]);
  const [puntosRedTraslado, setPuntosRedTraslado] = useState<PuntoRed[]>([]);
  const [guardandoConceptosTraslado, setGuardandoConceptosTraslado] = useState(false);
  const _syncKeyTraslado = JSON.stringify({
    oc: _obsAgTraslado?.otros_conceptos || [],
    pr: _obsAgTraslado?.puntos_red || [],
  });
  useEffect(() => {
    if (!esTraslado) return;
    const oc = _obsAgTraslado?.otros_conceptos;
    const pr = _obsAgTraslado?.puntos_red;
    setConceptosTraslado(Array.isArray(oc) ? oc : []);
    setPuntosRedTraslado(Array.isArray(pr) ? pr : []);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_syncKeyTraslado, esTraslado]);
  const conceptosTrasladoDirty =
    cambiaronItems(_obsAgTraslado?.otros_conceptos, conceptosTraslado) ||
    cambiaronItems(_obsAgTraslado?.puntos_red, puntosRedTraslado);
  const aprobacionTraslado = aprobacionDe(_obsAgTraslado);
  const conceptosTrasladoPendientes = conceptosPendientesAprobacion(_obsAgTraslado);
  const { handleUploadFile: _uploadFotoTraslado } = useUploadFile();
  const subirFotoEvidenciaTraslado = async (file: File) => {
    const r = await _uploadFotoTraslado(
      file,
      `${BucketAwtENUM.IMAGE_INSTALACION}/${ordentrabajo?.id_orden_trabajo}`,
    );
    return { url: r.url, fecha: new Date().toISOString() };
  };
  // Se guarda con el endpoint del técnico (solo pide `change_ordentrabajo`), no
  // con el PUT de agendamiento (pedía `change_agendamiento` → 403 al técnico).
  // Se envían SOLO las claves que cambia el técnico; el backend conserva el resto.
  const guardarConceptosTraslado = async () => {
    if (!ordentrabajo?.id_orden_trabajo) {
      toast.error("No se pudo resolver la orden de trabajo del traslado.");
      return;
    }
    const usuario = nombreUsuario(currentUser);
    const cambio = conceptosTrasladoDirty;
    // Regla: con el traslado iniciado, los cambios del técnico requieren
    // aprobación de Activaciones. Antes de iniciar, Activaciones los verá al
    // gestionar (no se marca pendiente).
    const aprobacion =
      cambio && trasladoIniciado(ordentrabajo)
        ? marcarAprobacionPendiente(usuario)
        : _obsAgTraslado?.conceptos_aprobacion || null;
    setGuardandoConceptosTraslado(true);
    try {
      await guardarObservacionesTecnico(ordentrabajo.id_orden_trabajo, {
        otros_conceptos: conceptosTraslado,
        otros_conceptos_historial: trazaOtrosConceptos(
          _obsAgTraslado?.otros_conceptos,
          conceptosTraslado,
          _obsAgTraslado?.otros_conceptos_historial,
          usuario,
          "tecnico",
        ),
        puntos_red: puntosRedTraslado,
        puntos_red_historial: trazaPuntosRed(
          _obsAgTraslado?.puntos_red,
          puntosRedTraslado,
          _obsAgTraslado?.puntos_red_historial,
          usuario,
          "tecnico",
        ),
        conceptos_aprobacion: aprobacion,
      });
      toast.success(
        aprobacion?.estado === "PENDIENTE" && cambio
          ? "Conceptos guardados. Quedan pendientes de aprobación por Activaciones."
          : "Conceptos del traslado guardados.",
      );
      await refreshData();
    } catch (e) {
      console.error("No se pudo guardar los conceptos del traslado", e);
      toast.error("No se pudo guardar los conceptos del traslado.");
    } finally {
      setGuardandoConceptosTraslado(false);
    }
  };

  ///* global state -----------------------
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen,
  );
  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore((s) => s.setIsGlobalLoading);
  const {
    productos: MATERIALES_UTILIZADOS,
    handleAgregarSeriesArrayProductos,
    setProductos: setMaterialesUtilizados,
  } = useCargarSeriesProductos();
  const productos_adicionales = useEquiposAdicionales((s) => s.productos);
  const setProductosAdicionales = useEquiposAdicionales((s) => s.setProductos);

  ///* form -----------------------
  //const form = useForm<SaveFormDataInstallTecAsig>({
  const form = useForm<any>({
    resolver: yupResolver(ordenTrabajoSubeTecnicoFormSchema) as any,
    defaultValues: {
      estado: true,
      es_conexion_tierra: false,
      es_regulador: false,
      ont_a_utilizar: ordentrabajo?.equipos_utilizados?.[0] || "",
      url_foto_identificacion_delantera:
        ordentrabajo?.preventa_data?.url_foto_identificacion_delantera || null,
      fecha_hora_inicio_instalacion:
        ordentrabajo?.fecha_hora_inicio_instalacion || "",
    },
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = form;

  // --- Excedente de fibra del TRASLADO (solo esTraslado) ---
  // Igual que el cable UTP: la opción aparece cuando el técnico agrega FIBRA
  // PLANA en los materiales. El excedente se lee EN VIVO (sondeo), así la
  // aprobación de Activaciones se refleja sin recargar. Se guarda con su propio
  // endpoint, no con el botón de conceptos.
  const _materialesFormFibra = useWatch({
    control: form.control,
    name: "materiales_utilizados",
  });
  const tieneFibraPlanaTraslado = tieneFibraPlana(MATERIALES_UTILIZADOS, _materialesFormFibra);
  // Metros de FIBRA PLANA cargados en Materiales ("Cantidad" por serie): es la
  // "fibra utilizada" que se sincroniza con el cuadro de excedente.
  const metrosFibraPlanaTraslado = metrosFibraPlana(MATERIALES_UTILIZADOS, _materialesFormFibra);
  const { excedente: excedenteFibraTraslado } = useExcedenteFibraLive(ordentrabajo, esTraslado);
  const [excedenteFibraDirty, setExcedenteFibraDirty] = useState(false);

  //mensaje
  // El prospecto solo aporta el aviso de "representante de persona con
  // discapacidad". Las vistas genéricas exigen api.view_prospecto, permiso que
  // el grupo TECNICO INSTALACIONES no tiene: si se consulta igual, el técnico
  // recibe el toast de 403 al abrir la orden. Solo se consulta con permiso, y
  // no se corta el render si el traslado no trae prospecto.
  const id_pros = ordentrabajo.prospecto_data?.id_prospecto;
  const puedeVerProspecto = hasPermission(PermissionsEnum.api_view_prospecto);
  const { data: dataProspecto } = useGetProspectoByIdProspecto(
    puedeVerProspecto ? id_pros : undefined,
  );

  const mensaje = [
    ordentrabajo.preventa_data?.requiere_contrato_fisico ? "FISICO" : "DIGITAL",
    dataProspecto?.es_curador_tutor
      ? "Es representante de persona con discapacidad: SI"
      : null,
  ]
    .filter(Boolean)
    .join("\n");

  ///* mutations -----------------------

  const udpdateInSiteUpdateOrdenTrabajo = useUpdateOrdenTrabajo<any>({
    enableRedirect: false,
  });
  // "Guardar Borrador" (traído de instalaciones/prod): guarda sin cambiar el
  // estado ni finalizar materiales/equipos y sin redirigir.
  const guardarBorradorMutation = useUpdateOrdenTrabajo<any>({
    enableRedirect: false,
    customSuccessMessage: "Borrador guardado correctamente",
  });
  // La tabla de MATERIALES solo se persistía con "Guardar Borrador": al
  // recargar, el cuadro de excedente quedaba (endpoint propio) pero las filas
  // de la tabla se perdían. Al guardar la "Fibra utilizada" se guarda también
  // la tabla en la OT (solo materiales_utilizados, sin tocar estado ni nada
  // más — mismo campo que escribe el borrador). Al recargar,
  // resetFormWithOTData repone el store desde la OT.
  const persistirMaterialesMutation = useUpdateOrdenTrabajo<any>({
    enableRedirect: false,
    enableSuccessAlert: false,
    enableErrorAlert: false,
    enableLoading: false,
  });
  const persistirMaterialesTraslado = async () => {
    if (!esTraslado || !ordentrabajo?.id_orden_trabajo) return;
    const materiales = handleAgregarSeriesArrayProductos(MATERIALES_UTILIZADOS);
    if (!materiales.length) return;
    try {
      await persistirMaterialesMutation.mutateAsync({
        id: ordentrabajo.id_orden_trabajo,
        data: { materiales_utilizados: materiales } as any,
      });
    } catch (e) {
      // Si falla, el borrador sigue siendo el plan B para no perder la tabla.
      console.error("No se pudo guardar la tabla de materiales del traslado", e);
    }
  };
  // SSID / contraseña WiFi viven en el CONTRATO, no en la OT (igual que en
  // instalaciones/prod): si el técnico los cambia se actualiza el contrato al
  // guardar borrador o al finalizar. Sin esto, al refrescar la OT los campos
  // volvían a lo que tenía el contrato y parecía que "se borraban".
  const updateContratoMutation = useUpdateContrato<Pick<Contrato, "ssid" | "password_wifi">>({
    enableSuccessAlert: false,
    customSuccessCallback: () => {
      toast.success("SSID y contraseña actualizados correctamente");
    },
  });
  const guardarWifiContrato = async (data: any) => {
    const idContrato = ordentrabajo?.contrato_data?.id_contrato;
    if (!idContrato) return;
    const ssid = data?.ssid?.trim();
    const password_wifi = data?.password_wifi?.trim();
    const cambios: Partial<Pick<Contrato, "ssid" | "password_wifi">> = {};
    if (ssid && ordentrabajo?.contrato_data?.ssid !== ssid) cambios.ssid = ssid;
    if (password_wifi && ordentrabajo?.contrato_data?.password_wifi !== password_wifi) {
      cambios.password_wifi = password_wifi;
    }
    if (Object.keys(cambios).length === 0) return;
    await updateContratoMutation.mutateAsync({ id: idContrato, data: cambios as any });
  };

  const updateOrdenTrabajoMutation =
    useUpdateOrdenTrabajo<SaveOTTecnicoInstallPendingData>({
      navigate,
      returnUrl: returnUrlInstalacionesTecnicoPage,
      customMessage: "Orden de trabajo subida correctamente",
      customSuccessCallback: () => {
        clearAllMaterials();
      },
    });
  const {
    data: dataUbicacionProd,
    isLoading: isloadingUbProducto,
    // isRefetching: isRefetchingUbProducto
  } = useFetchUbicacionProductosEnabled({
    enabled: true,
    params: {
      page_size: 1000,
      page: 1,
      categoria_producto: CategoryProducCodeEnum.EQUIPOS,
      ubicacion: ordentrabajo?.flota_data?.ubicacion,
      // filterByState: false
    },
  });
  //reset
  useEffect(() => {
    setValueTab(1)

  }, [ordentrabajo?.id_orden_trabajo])
  // useEffect(()=>{
  //   // const corporatePlansFiltered = paymentMethodsFilterPaging?.filter((x)=>x.nombre.includes("DÉBITO") || x.nombre.includes("TRANSFERENCIA") || x.nombre.includes("CONTRAFACTURA") || x.nombre.includes("OTRO")) || []
  //   getpaymentMethodsFilterPaging()
  //   setPaymentMethods(paymentMethodsFilterPaging)

  // },[paymentMethodsFilterPaging])

  ///* handlers ============================================
  const onSave = async (data: any) => {
    if (!isValid) return;

    if (!form.getValues()?.ont_a_utilizar) {
      return setAlert(true, "Debe seleccionar un ONT", AlertSeverityEnum.error);
    }
    ////* VALIDATE equipos and materials -----------------------
    const equiposUtilizados: EquiposUtilizadosOTTableType[] =
      useMaterialesUtilizadosStore.getState().equipos_utilizados;
    // const materialesUtilizados: EquiposUtilizadosOTTableType[] =
    //   useMaterialesUtilizadosStore.getState().materiales_utilizados;

    // validate activacion state ----------------------
    if (
      ordentrabajo?.estado_activacion !==
      EstadosActivacionInstallOTEnumChoice.GESTIONADA
    ) {
      return setAlert(
        true,
        "La orden de trabajo aún no ha sido gestionada por ACTIVACIONES",
        AlertSeverityEnum.error,
      );
    }

    let thereAreItemsWithoutSeries = false;
    let thereAreItemsWithZeroQuantity = false;
    // let isSelectedONT = false;
    // let isMoreThanOneONT = false;
    const zeroQuantity = "0.00";
    // let isSelectedFibra = false;
    // let isSelectedUTP = false;
    ///* validate EQUIPOS -------------------
    if (!equiposUtilizados.length && !data.equipos_utilizados) {
      return setAlert(
        true,
        "No se han agregado EQUIPOS a la orden de trabajo",
        AlertSeverityEnum.error,
      );
    }

    const mappedEquiposUtilizados = equiposUtilizados.map((item) => {
      const itemCantidad = item?.cantidad as number;
      return {
        cantidad: itemCantidad?.toFixed(2),
        id: item?.id,
        codigo: item?.producto_data?.codigo,
        series: item?.selected_series || [],

        contiene_serie: item?.contiene_serie,
        producto_data: item?.producto_data,
      };
    });

    // validation logic -------
    const StoredEquiposUtilizados =
      ordentrabajo?.equipos_utilizados as MaterialTransferido[];
    if (StoredEquiposUtilizados && StoredEquiposUtilizados?.length > 0) {
      StoredEquiposUtilizados?.forEach((item) => {
        if (item?.contiene_serie && !item?.series?.length) {
          thereAreItemsWithoutSeries = true;
        }
        if (item?.cantidad === zeroQuantity) {
          thereAreItemsWithZeroQuantity = true;
        }
      });
    } else {
      mappedEquiposUtilizados.forEach((item) => {
        if (item?.contiene_serie && !item?.series?.length) {
          thereAreItemsWithoutSeries = true;
        }
        if (item?.cantidad === zeroQuantity) {
          thereAreItemsWithZeroQuantity = true;
        }
      });
    }

    // validation alerts -------
    if (thereAreItemsWithZeroQuantity) {
      setAlert(true, "Hay EQUIPOS sin cantidad", AlertSeverityEnum.error);
      return;
    }
    if (thereAreItemsWithoutSeries) {
      setAlert(
        true,
        "Hay EQUIPOS sin series asignadas",
        AlertSeverityEnum.error,
      );
    }

    if (ordentrabajo?.coordenadas != data?.coordenadas) {
      if (ordentrabajo?.historial_cambios_coordenadas) {
        data.historial_cambios_coordenadas = [
          ...ordentrabajo?.historial_cambios_coordenadas,
          {
            usuario: currentUser?.username,
            fecha_cambio: new Date().toISOString(),
            coordenada_anterior: ordentrabajo?.coordenadas,
            coordenada_nueva: data?.coordenadas,
          },
        ];
      } else {
        data.historial_cambios_coordenadas = [
          {
            usuario: currentUser?.username,
            fecha_cambio: new Date().toISOString(),
            coordenada_anterior: ordentrabajo?.coordenadas,
            coordenada_nueva: data?.coordenadas,
          },
        ];
      }
    }

    //para limpiar los productos con la data necesaria y agregarles sus series con sus cantidades
    const MATERIALES_UTILIZADOS_FILTRADOS = handleAgregarSeriesArrayProductos(
      MATERIALES_UTILIZADOS,
    );
    if (MATERIALES_UTILIZADOS_FILTRADOS.length === 0) {
      setAlert(
        true,
        "No se han agregado materiales de instalación.",
        AlertSeverityEnum.error,
      );
      return;
    }
    // TRASLADO: la fibra se reconoce por descripción o código (esFibraPlana)
    // y debe registrar al menos 1 metro en "Cantidad". En los demás flujos la
    // validación por códigos queda exactamente igual.
    if (esTraslado) {
      if (!tieneFibraPlanaTraslado) {
        setAlert(
          true,
          "No se ha agregado FIBRA PLANA a los materiales de instalación.",
          AlertSeverityEnum.error,
        );
        return;
      }
      if (metrosFibraPlanaTraslado < 1) {
        setAlert(
          true,
          "La FIBRA de los materiales debe registrar al menos 1 metro (campo Cantidad de la serie).",
          AlertSeverityEnum.error,
        );
        return;
      }
    } else if (
      !MATERIALES_UTILIZADOS_FILTRADOS.some(
        (item) =>
          item.codigo == "MFO.015.0082" || item.codigo == "MFO.015.0046",
      )
    ) {
      setAlert(
        true,
        "No se ha agregado FIBRA PLANA a los materiales de instalación.",
        AlertSeverityEnum.error,
      );
      return;
    }

    console.log(MATERIALES_UTILIZADOS_FILTRADOS);

    for (const el of MATERIALES_UTILIZADOS_FILTRADOS) {
      if (!el.contiene_serie) continue;

      const seriesLen = el.series?.length ?? 0;
      const cantidad = el.cantidad ?? 0;
      const codigo = el.producto_data?.codigo ?? "(sin código)";

      if (seriesLen == 0) {
        return setAlert(
          true,
          `El producto con el código ${codigo} tiene series pendientes por cargar`,
          AlertSeverityEnum.error,
        );
      }

      if (seriesLen != cantidad) {
        return setAlert(
          true,
          `El producto con el código ${codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`,
          AlertSeverityEnum.error,
        );
      }
    }
    const hayProdAdicionalesInvalidos = productos_adicionales.some(
      (obj) =>
        !obj.series || (Array.isArray(obj.series) && obj.series.length === 0),
    );
    if (hayProdAdicionalesInvalidos) {
      return setAlert(
        true,
        "Algunos productos adicionales tienen series pendientes por cargar",
        AlertSeverityEnum.error,
      );
    }

    ///* upd ----------------
    if (!!ordentrabajo) {
      updateOrdenTrabajoMutation.mutate({
        id: ordentrabajo?.id_orden_trabajo!,
        data: {
          estado_orden_trabajo: isCorrentingData
            ? EstadosOrdenTrabajoEnumChoice.REALIZADA_ACTUALIZADA
            : EstadosOrdenTrabajoEnumChoice.REALIZADA,
          // estado_orden_trabajo: EstadosOrdenTrabajoEnumChoice.EN_ESPERA,
          finalizar_materiales: true,
          finalizar_equipos: true,

          codigo_bobina: data.codigo_bobina,
          splitter: data.splitter,
          manga: data.manga,
          color_hilo: data.color_hilo,
          num_hilo: data.num_hilo,
          nap: data.nap,
          puerto: data.puerto,
          distancia: data.distancia,
          test_5g: data.test_5g,
          potencia_dbm: data.potencia_dbm,
          potencia_ont: data.potencia_ont,
          es_conexion_tierra: data.es_conexion_tierra,
          es_regulador: data.es_regulador,
          ubicacion_equipo_ac: data.ubicacion_equipo_ac,
          ubicacion_ont: data.ubicacion_ont,
          celular_2: data.celular_2,
          email: data.email,
          persona_referencia_nombre: data.persona_referencia_nombre,
          persona_referencia_celular: data.persona_referencia_celular,
          persona_referencia_celular_2: data.persona_referencia_celular_2,
          persona_referencia_parentesco: data.persona_referencia_parentesco,
          incidencia: data.incidencia,
          prioridad_incidencia: data.prioridad_incidencia,
          observaciones: {
            ...ordentrabajo?.observaciones,
            observacion_tecnico: data.observacion_tecnico,
            observacion_incidencia: data.observacion_incidencia,
          },
          punta_final: "0",
          // punta_final:
          //   materialesUtilizados
          //     .find((item) => item?.producto_data?.es_fibra)
          //     ?.puntaFinal?.toFixed(2) || "0.00",

          equipos_utilizados: data?.equipos_utilizados,
          // StoredEquiposUtilizados && StoredEquiposUtilizados?.length>0?
          //   StoredEquiposUtilizados
          //   :cleanedEquiposUtilizados as MaterialTransferido[],
          materiales_utilizados: MATERIALES_UTILIZADOS_FILTRADOS,
          materiales_equipos_adicionales: productos_adicionales,
          routers_adicionales_instalados: data?.routers_adicionales_instalados,
          puntos_red_instalados: data?.puntos_red_instalados,
          historial_cambios_coordenadas:
            data?.historial_cambios_coordenadas || [],
          coordenadas: data?.coordenadas,
          fecha_hora_fin_instalacion:
            ordentrabajo?.estado_activacion ===
              EstadosActivacionInstallOTEnumChoice.GESTIONADA
              ? dayjs().toISOString()
              : undefined,
        },
      });
      // WiFi del contrato (igual que instalaciones/prod)
      guardarWifiContrato(data).catch((e) =>
        console.error("No se pudo actualizar el WiFi del contrato", e),
      );

      clearAllMaterials();
      return;
    }
  };

  // ---- Guardar Borrador (traslado) ----
  // Misma función que en instalaciones (prod): guarda lo que lleva el técnico
  // (datos técnicos, materiales, equipos, observaciones, coordenadas) SIN
  // cambiar el estado, sin finalizar materiales/equipos (no hay egreso de
  // inventario) y sin las validaciones de cierre. Única regla: el traslado
  // debe estar iniciado. Así Activaciones ve la NAP/puerto antes de gestionar.
  const onSaveBorrador = async () => {
    const data: any = form.getValues();
    if (!data?.fecha_hora_inicio_instalacion && !ordentrabajo?.fecha_hora_inicio_instalacion) {
      return setAlert(
        true,
        "Debe iniciar el traslado para guardar el borrador.",
        AlertSeverityEnum.error,
      );
    }
    const materialesFiltrados = handleAgregarSeriesArrayProductos(MATERIALES_UTILIZADOS);
    try {
      await guardarBorradorMutation.mutateAsync({
        id: ordentrabajo?.id_orden_trabajo!,
        data: {
          es_borrador: true,
          // sin estado_orden_trabajo ni finalizar_materiales/equipos: es borrador

          codigo_bobina: data.codigo_bobina,
          splitter: data.splitter,
          manga: data.manga,
          color_hilo: data.color_hilo,
          num_hilo: data.num_hilo,
          nap: data.nap,
          puerto: data.puerto,
          distancia: data.distancia,
          test_5g: data.test_5g,
          potencia_dbm: data.potencia_dbm,
          potencia_ont: data.potencia_ont,
          es_conexion_tierra: data.es_conexion_tierra,
          es_regulador: data.es_regulador,
          ubicacion_equipo_ac: data.ubicacion_equipo_ac,
          ubicacion_ont: data.ubicacion_ont,
          celular_2: data.celular_2,
          email: data.email,
          persona_referencia_nombre: data.persona_referencia_nombre,
          persona_referencia_celular: data.persona_referencia_celular,
          persona_referencia_celular_2: data.persona_referencia_celular_2,
          persona_referencia_parentesco: data.persona_referencia_parentesco,
          incidencia: data.incidencia,
          prioridad_incidencia: data.prioridad_incidencia,
          observaciones: {
            ...ordentrabajo?.observaciones,
            observacion_tecnico: data.observacion_tecnico,
            observacion_incidencia: data.observacion_incidencia,
          },
          punta_final: "0",

          equipos_utilizados: data?.equipos_utilizados,
          materiales_utilizados: materialesFiltrados,
          materiales_equipos_adicionales: productos_adicionales,
          routers_adicionales_instalados: data?.routers_adicionales_instalados,
          puntos_red_instalados: data?.puntos_red_instalados,
          puntos_red_no_instalados: data?.puntos_red_no_instalados,
          historial_cambios_coordenadas: calcularHistorialCambiosCoordenadas({
            ordentrabajo,
            coordenadasNuevas: data?.coordenadas,
            usuario: currentUser?.username,
          }),
          coordenadas: data?.coordenadas,
        },
      });
      try {
        await guardarWifiContrato(data);
      } catch (e) {
        console.error("No se pudo actualizar el WiFi del contrato", e);
      }
      await refreshData();
    } catch (e) {
      // El motivo ya lo mostró el cliente HTTP.
      console.error("No se pudo guardar el borrador del traslado", e);
    }
  };

  const refreshData = async () => {
    // Estado en vivo de las fotos del traslado (iniciar/finalizar usan el PUT).
    queryClient.invalidateQueries({
      queryKey: [FOTOS_TRASLADO_LIVE_KEY, ordentrabajo?.id_orden_trabajo?.toString() || ""],
    });
    await queryClient.invalidateQueries({
      queryKey: [
        OrdenTrabajoQueryKeysEnum.OrdenTrabajo,
        ordentrabajo?.id_orden_trabajo?.toString() || "",
      ],
    });
  };

  const resetFormWithOTData = (ordenTrabajo: OrdenTrabajo) => {
    if (!ordenTrabajo?.id_orden_trabajo) return;

    const { prospecto_data, preventa_data, agendamiento_data, ...rest } =
      ordenTrabajo;
    const estado_navegacion_contrato = rest?.contrato_data?.estado_navegacion;
    const tag = rest?.contrato_data?.tag;
    delete rest?.contrato_data;
    if (ordenTrabajo?.materiales_utilizados?.length > 0) {
      setMaterialesUtilizados(
        (ordenTrabajo?.materiales_utilizados as any[]) || [],
      );
    }
    if (ordenTrabajo?.materiales_equipos_adicionales?.length > 0) {
      setProductosAdicionales(
        (ordenTrabajo?.materiales_equipos_adicionales as any[]) || [],
      );
    }

    ///* reset form -------------
    reset({
      ...prospecto_data,
      ...preventa_data,
      ...agendamiento_data,
      ...rest,
      fecha_hora_inicio_instalacion:
        ordenTrabajo?.fecha_hora_inicio_instalacion,
      estado_navegacion_contrato: estado_navegacion_contrato,
      planLabel: ordenTrabajo?.plan_data?.nombre || "",
      flotaLabel: ordenTrabajo?.flota_data?.nombre || "",
      tipo_instalacion:
        ordenTrabajo?.tipo_instalacion || preventa_data?.tipo_instalacion || "",
      subtipo_instalacion: ordenTrabajo?.subtipo_instalacion || "",
      valor_instalacion: preventa_data?.valor_instalacion || "",
      observacion_activacion:
        ordenTrabajo?.observaciones?.observacion_activacion,

      observacion_1: ordenTrabajo?.preventa_data?.observaciones?.observacion_1,
      observacion_2: ordenTrabajo?.preventa_data?.observaciones?.observacion_2,
      observacion_tecnico:
        ordenTrabajo?.observaciones?.observacion_tecnico || "",
      observacion_llamada:
        agendamiento_data?.observaciones?.observacion_llamada,
      observacion_incidencia:
        ordenTrabajo?.observaciones?.observacion_incidencia || "",

      // WiFi: vive en el contrato (igual que en instalaciones/prod)
      ssid: ordenTrabajo?.contrato_data?.ssid || "",
      password_wifi: ordenTrabajo?.contrato_data?.password_wifi || "",

      metraje_autorizado: rest?.ciudad_data?.metraje_autorizado || "0",

      es_conexion_tierra: !!rest?.es_conexion_tierra,
      es_regulador: !!rest?.es_regulador,

      ///* Activacion ---
      rawNap: rest.nap_data,
      nap: rest.nap || "",
      ont_a_utilizar: rest?.equipos_utilizados?.[0] || "",
      puntos_red_instalados: rest?.puntos_red_instalados || "0",
      puntos_red_no_instalados: rest?.puntos_red_no_instalados || "0",
      routers_adicionales_instalados: rest?.routers_adicionales_instalados || 0,
      forma_pago_adicionales_tecnico:
        rest?.forma_pago_adicionales_tecnico || null,

      ...(ordenTrabajo?.forma_pago_adicionales_tecnico &&
        Object.keys(ordenTrabajo?.forma_pago_adicionales_tecnico).length >
        0 && {
        forma_pago_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.forma_pago,
        metodo_pago_mensualidad_aux:
          form.getValues()?.forma_pago_adicionales_tecnico
            ?.metodo_pago_mensualidad,
        valor_instalacion_total_aux:
          form.getValues()?.forma_pago_adicionales_tecnico
            ?.valor_instalacion_total,
        valor_instalacion_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.valor_instalacion,
        valor_instalacion_iva_aux:
          form.getValues()?.forma_pago_adicionales_tecnico
            ?.valor_instalacion_iva,
        numero_cuenta_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.numero_cuenta,
        tipo_cuenta_bancaria_aux:
          form.getValues()?.forma_pago_adicionales_tecnico
            ?.tipo_cuenta_bancaria,
        numero_tarjeta_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.numero_tarjeta,
        entidad_financiera_aux:
          form.getValues()?.forma_pago_adicionales_tecnico
            ?.entidad_financiera,
        codigo_forma_pago_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.codigo_forma_pago,
        tipo_contrato_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.tipo_contrato,
        tarjeta_aux:
          form.getValues()?.forma_pago_adicionales_tecnico?.tarjeta,
      }),
      equipos_adicionales_preventa:
        ordenTrabajo?.preventa_data?.equipos_adicionales || null,
      tag: tag,
    } as unknown as any);
  };

  ///* effects -----------------------
  useEffect(() => {
    setMaterialesUtilizados([]);
    setProductosAdicionales([]);
    setProductosAdicionales(ordentrabajo?.materiales_equipos_adicionales || []);
  }, []);
  useEffect(() => {
    if (!ordentrabajo?.id_orden_trabajo) return;

    resetFormWithOTData(ordentrabajo);
  }, [ordentrabajo]);
  
  useEffect(() => {
    const auxONTOptions = dataUbicacionProd?.data?.data
      ?.map((item) => {
        console.log({ itemdesupuestaont: item });
        const auxONT = item.series;
        const auxONTData: any[] = [];
        if (item.producto_data?.es_ont && auxONT?.length > 0) {
          auxONT.forEach((ont) => {
            console.log({ item });
            const auxONTSplit = ont.split("-");
            auxONTData.push({
              name: `${item.producto_data?.descripcion} - ${auxONTSplit[0]}`,
              codigo: item.producto_data?.codigo,
              cantidad: "1",
              series: [ont],
            });
          });
          return auxONTData;
        }
        return null;
      })
      ?.filter((x) => x != null);
    console.log({ auxONTOptions });
    setOptionsONT(auxONTOptions?.flat() || []);

    if (!form.getValues().ont_a_utilizar) return;

    form.reset({
      ...form.getValues(),
      ont_a_utilizar: form.getValues()?.equipos_utilizados?.[0] || {},
    });
  }, [isloadingUbProducto, dataUbicacionProd]);

  const observacionActualizacionTecnico = useWatch({
    control: form.control,
    name: "observaciones.observacion_actualizacion_tecnico",
  });
  const estadoOrdenTrabajo = useWatch({
    control: form.control,
    name: "estado_orden_trabajo",
  });
  const motivoRechazoNombre = useWatch({
    control: form.control,
    name: "motivo_rechazo_data.nombre",
  });
  const fechaSolicitadaActualizacionTecnico = useWatch({
    control: form.control,
    name: "observaciones.fecha_solicitada_actualizacion_tecnico",
  });
  const fechaHoraInicioInstalacion = useWatch({
    control: form.control,
    name: "fecha_hora_inicio_instalacion",
    defaultValue: ordentrabajo?.fecha_hora_inicio_instalacion || "",
  });

  const hasFechaHoraInicioInstalacion =
    !!fechaHoraInicioInstalacion &&
    String(fechaHoraInicioInstalacion).trim() !== "" &&
    String(fechaHoraInicioInstalacion).toLowerCase() !== "null" &&
    String(fechaHoraInicioInstalacion).toLowerCase() !== "undefined";

  return (
    <TabsFormBoxScene
      titlePage={title}
      showBtns={false}
      // // custom btns ---------
      showCustomBtns={true}
      customBtns={
        <CustomButtunsRejectConfirm
          confirmTextBtn={isCorrentingData ? "Actualizar" : "Guardar"}
          showRejectBtn={!isCorrentingData}
          rejectTextBtn={"Reportar Novedad"}
          onCancel={() => {
            setConfirmDialog({
              isOpen: true,
              title: "Abandonar Formulario",
              subtitle:
                "¿Está seguro de abandonar el formulario? Se perderán todos los cambios realizados.",
              onConfirm: () => {
                setConfirmDialogIsOpen(false);
                clearAllMaterials();
                navigate(returnUrlInstalacionesTecnicoPage);
              },
              confirmTextBtn: "SI",
              cancelTextBtn: "NO",
            });
          }}
          //  ----------- CONFIRMAR -----------
          onConfirm={
            esTraslado
              ? () => {
                  // Traslado: requiere activación GESTIONADA (como instalaciones)
                  // + mín 2 Fotos de proceso, y finaliza con el modal de fotos.
                  if (
                    ordentrabajo?.estado_activacion !==
                    EstadosActivacionInstallOTEnumChoice.GESTIONADA
                  ) {
                    setAlert(
                      true,
                      "El traslado aún no ha sido gestionado por ACTIVACIONES.",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  // Fotos de proceso (punto inicial + punto final) obligatorias
                  // antes de finalizar el traslado.
                  // Fotos de ingreso: si Activaciones eliminó alguna, hay que
                  // volver a subirla antes de finalizar.
                  const _faltanIngreso = resumenFotosTraslado(otFotosTraslado).faltanIngreso;
                  if (_faltanIngreso > 0) {
                    setValueTab(5);
                    setAlert(
                      true,
                      `Activaciones eliminó ${
                        _faltanIngreso === 1 ? "1 foto" : `${_faltanIngreso} fotos`
                      } de ingreso. Vuelve a subirla${_faltanIngreso === 1 ? "" : "s"} antes de finalizar (pestaña FOTOS).`,
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  const _faltanProceso = fotosProcesoFaltantes(otFotosTraslado);
                  if (_faltanProceso.length > 0) {
                    setValueTab(5);
                    setAlert(
                      true,
                      `Antes de finalizar carga las fotos de proceso: ${_faltanProceso.join(" y ")} (pestaña FOTOS).`,
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  // Materiales: este camino NO pasa por onSave (el modal de
                  // fotos hace el PUT directo), así que las validaciones de
                  // materiales van aquí: debe haber materiales y FIBRA PLANA
                  // (por descripción/código) con al menos 1 metro en Cantidad.
                  // Mira el store del técnico Y lo ya guardado en la OT.
                  if (
                    !(MATERIALES_UTILIZADOS?.length > 0)
                    && !(Array.isArray(_materialesFormFibra) && _materialesFormFibra.length > 0)
                  ) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "No se han agregado materiales de instalación (pestaña MATERIALES).",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  if (!tieneFibraPlanaTraslado) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "No se ha agregado FIBRA PLANA a los materiales de instalación (pestaña MATERIALES).",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  if (metrosFibraPlanaTraslado < 1) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "La FIBRA de los materiales debe registrar al menos 1 metro (campo Cantidad de la serie).",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  // Otros conceptos del traslado: no se puede finalizar con cambios
                  // sin guardar ni con conceptos pendientes de aprobación.
                  if (conceptosTrasladoDirty) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "Tienes cambios sin guardar en los conceptos del traslado (pestaña MATERIALES).",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  if (conceptosTrasladoPendientes) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "Los conceptos agregados al traslado deben ser aprobados por ACTIVACIONES antes de finalizar.",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  // Excedente de fibra: no se finaliza con metros sin guardar ni
                  // con un excedente (sobre los metros gratis) que Activaciones
                  // todavía no aprueba.
                  if (excedenteFibraDirty) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "Tienes la fibra utilizada sin guardar (pestaña MATERIALES, cuadro Fibra utilizada). Guárdala o déjala como estaba.",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  if (excedenteFibraPendiente(excedenteFibraTraslado)) {
                    setValueTab(4);
                    setAlert(
                      true,
                      "El excedente de fibra debe ser aprobado por ACTIVACIONES antes de finalizar.",
                      AlertSeverityEnum.error,
                    );
                    return;
                  }
                  // Solo si es RECAUDACIÓN TÉCNICO: confirmar que recaudó el dinero
                  // antes de finalizar. Si no es recaudación técnico, no se muestra.
                  if (esRecaudacionTecnico) {
                    setConfirmDialog({
                      isOpen: true,
                      title: "Confirmar recaudación",
                      subtitle: `Este traslado es de RECAUDACIÓN TÉCNICO. ¿Confirmás que recaudaste ${
                        valorTrasladoFmt || "el valor indicado"
                      } del cliente antes de finalizar?`,
                      onConfirm: () => {
                        setConfirmDialogIsOpen(false);
                        setOpenFinalizarTraslado(true);
                      },
                      confirmTextBtn: "SÍ, recaudé",
                      cancelTextBtn: "NO",
                    });
                    return;
                  }
                  setOpenFinalizarTraslado(true);
                }
              : //() => onSave(form.getValues())
            handleSubmit(onSave, (err) => {
              // console.log({dataBuena:form.getValues()})
              // console.log({ err })
              //return setAlert(true,`llego al onsave`, AlertSeverityEnum.error)
              if (
                // err.ipv4_actual?.message ||
                // err.puerto?.message ||
                // err.pppoe?.message ||
                // err.pppassword?.message ||
                ordentrabajo?.estado_activacion !==
                EstadosActivacionInstallOTEnumChoice.GESTIONADA
              ) {
                setAlert(
                  true,
                  "La orden de trabajo aún no ha sido gestionada por ACTIVACIONES",
                  AlertSeverityEnum.error,
                );
              }
              // console.log(form.getValues())
              return setAlert(
                true,
                `Faltan campos por llenar: ${Object.keys(err).join(", ")?.replaceAll("_", " ")?.toUpperCase()}`,
                AlertSeverityEnum.error,
              );
            })
          }
          //  ----------- RECHAZAR -----------
          onReject={() => {
            // Prerechazo
            setOpenRejectModal(true);
          }}
          // auxiliar btn (borrador + refresh) ----------------
          showAuxiliarBtn={!isCorrentingData}
          auxiliarBtn={
            <>
              {esTraslado && (
                <Grid item>
                  <LoadingButton
                    variant="outlined"
                    color="primary"
                    loading={guardarBorradorMutation.isPending}
                    onClick={onSaveBorrador}
                  >
                    Guardar Borrador
                  </LoadingButton>
                </Grid>
              )}
              <SingleIconButton
                label="Actualizar"
                color="success"
                startIcon={<RefreshIcon />}
                onClick={() => {
                  setConfirmDialog({
                    isOpen: true,
                    title: "Refrescar Datos",
                    subtitle:
                      "Al refrescar los datos se perderán los cambios realizados. ¿Desea continuar?",
                    onConfirm: () => {
                      setConfirmDialogIsOpen(false);
                      refreshData();
                    },
                    confirmTextBtn: "SI",
                    cancelTextBtn: "NO",
                  });
                }}
              />
            </>
          }
        />
      }
      // // tabs ---------
      tabs={
        <>
          {observacionActualizacionTecnico &&
            estadoOrdenTrabajo ===
            EstadosOrdenTrabajoEnumChoice.ESPERA_ACTUALIZAR ? (
            <Grid container spacing={2} justifyContent={"center"} my={2}>
              <CustomAlertCard
                alertTitle="Actualización solicitada por Auditoría"
                alertMessage={`${texto.correccion_solicitada_tecnico_auditoria} \n ${motivoRechazoNombre}: ${observacionActualizacionTecnico} (${dayjs(fechaSolicitadaActualizacionTecnico).format("DD/MM/YYYY HH:mm:ss") || "Fecha no definida"})`}
                bgColorAlert="RED"
                alertColor="error"
              />
            </Grid>
          ) : null}
          <Grid container spacing={2} justifyContent={"center"} my={1}>
            {hasFechaHoraInicioInstalacion ? (
              <>
                <Typography variant="body1" color="success">
                  {`
                Instalación iniciada a las
                ${dayjs(fechaHoraInicioInstalacion).format("HH:mm:ss")}
                del día ${dayjs(fechaHoraInicioInstalacion).format("DD/MM/YYYY")}
                `}
                </Typography>
                <br />
                <Grid
                  {...gridSizeMdLg12}
                  sx={{ marginTop: 2 }}
                  container
                  justifyContent={"center"}
                >
                  <CardPersonalizado
                    alertTitle="Tipo de contrato"
                    alertMessage={
                      mensaje
                    }
                    bgColorAlert="GRAY"
                    alertColor="error"
                  />
                </Grid>
                {esTraslado && metodoRecaudacionTraslado && (
                  <Grid {...gridSizeMdLg12} container justifyContent={"center"} sx={{ mt: 1 }}>
                    <CardPersonalizado
                      alertTitle="Método de recaudación"
                      alertMessage={metodoRecaudacionTraslado}
                      bgColorAlert={esRecaudacionTecnico ? "YELLOW" : "GRAY"}
                      alertColor={esRecaudacionTecnico ? "warning" : "info"}
                    />
                  </Grid>
                )}
              </>
            ) : (
              <Grid container {...gridSizeMdLg12} gap={1}>
                {(permissionStatus === "denied" ||
                  permissionStatus === "prompt") && (
                    <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                      <CustomAlertCard
                        alertTitle="Habilite el acceso a la ubicación"
                        alertMessage={
                          error ??
                          "Necesitamos acceso a tu ubicación para continuar. Actívala en tu navegador y vuelve a intentarlo."
                        }
                        bgColorAlert="RED"
                        alertColor="error"
                      />
                    </Grid>
                  )}
                {permissionStatus === "loading" && (
                  <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                    <CustomAlertCard
                      alertTitle="Habilite el acceso a la ubicación"
                      alertMessage={
                        coords?.accuracy
                          ? `Precisión actual: ${Math.round(coords.accuracy)}m — esperando señal GPS...`
                          : "Iniciando GPS, mantente en campo abierto para mejor señal."
                      }
                      alertColor="info"
                    />
                  </Grid>
                )}

                <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                  <CardPersonalizado
                    alertTitle="Tipo de contrato"
                    alertMessage={
                      // ordentrabajo.preventa_data.requiere_contrato_fisico? "FISICO": "DIGITAL"
                      mensaje
                      //  dataProspecto?.es_curador_tutor}
                    }
                    bgColorAlert="GRAY"
                    alertColor="error"
                  />
                </Grid>
                {esTraslado && metodoRecaudacionTraslado && (
                  <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                    <CardPersonalizado
                      alertTitle="Método de recaudación"
                      alertMessage={metodoRecaudacionTraslado}
                      bgColorAlert={esRecaudacionTecnico ? "YELLOW" : "GRAY"}
                      alertColor={esRecaudacionTecnico ? "warning" : "info"}
                    />
                  </Grid>
                )}
                <Grid {...gridSizeMdLg12} container justifyContent={"center"}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="info"
                    onClick={async () => {
                      setIsGlobalLoading(true);
                      // GPS con manejo de error: si getCurrentCoords() rechaza
                      // (permiso denegado / sin señal / escritorio) NO debe colgar
                      // el botón ni dejar el loading pegado (antes lanzaba y el modal
                      // nunca abría).
                      let location: { lat: number; lng: number; accuracy?: number } | null =
                        coords ?? null;
                      if (!location) {
                        try {
                          // Timeout: si el GPS no responde en 8s (escritorio / señal
                          // pobre) no debe colgar el botón. Se cae al fallback de
                          // coordenadas del traslado más abajo.
                          location = await Promise.race([
                            getCurrentCoords(),
                            new Promise<never>((_, rej) =>
                              setTimeout(() => rej(new Error("gps-timeout")), 8000),
                            ),
                          ]);
                        } catch {
                          location = null;
                        }
                      }
                      setIsGlobalLoading(false);

                      // Traslado: abre el modal de fotos de ingreso. Si no hubo GPS
                      // en vivo, se usan las coordenadas ya registradas del traslado
                      // (destino planificado) para no bloquear la subida de fotos.
                      if (esTraslado) {
                        let loc = location;
                        if (!loc) {
                          const fallback =
                            (ordentrabajo as any)?.coordenadas ||
                            (ordentrabajo as any)?.agendamiento_data?.coordenadas ||
                            "";
                          if (typeof fallback === "string" && fallback.includes(",")) {
                            const [la, ln] = fallback
                              .split(",")
                              .map((n: string) => Number(n.trim()));
                            if (!isNaN(la) && !isNaN(ln)) loc = { lat: la, lng: ln, accuracy: 0 };
                          }
                        }
                        if (!loc) {
                          toast.error(
                            "No se pudo obtener la ubicación (GPS) ni hay coordenadas del traslado.",
                          );
                          return;
                        }
                        setIniciarLocationTraslado({ lat: loc.lat, lng: loc.lng });
                        setOpenIniciarTraslado(true);
                        return;
                      }

                      // Instalación: requiere GPS (comportamiento intacto).
                      if (!location) {
                        toast.error("No se pudo obtener la ubicación actual");
                        return;
                      }
                      setConfirmDialog({
                        isOpen: true,
                        title: "Iniciar Instalación",
                        subtitle: `Al iniciar la instalación se registrará la hora de inicio de instalación y se actualizarán las coordenadas: (${location.lat}, ${location.lng}). ¿Desea continuar?`,
                        onConfirm: () => {
                          const updateDataCoordenadas =
                            ordentrabajo?.historial_cambios_coordenadas
                              ? [...ordentrabajo?.historial_cambios_coordenadas]
                              : [];
                          updateDataCoordenadas.push({
                            usuario: currentUser?.username || "",
                            fecha_cambio: new Date().toISOString(),
                            coordenada_anterior:
                              ordentrabajo?.coordenadas || "",
                            coordenada_nueva: `${location.lat},${location.lng}`,
                          });
                          udpdateInSiteUpdateOrdenTrabajo.mutateAsync(
                            {
                              id: ordentrabajo?.id_orden_trabajo!,
                              data: {
                                fecha_hora_inicio_instalacion: dayjs(),
                                coordenadas: `${location.lat},${location.lng}`,
                                historial_cambios_coordenadas:
                                  updateDataCoordenadas,
                              },
                            },
                            {
                              onSuccess: () => {
                                refreshData();
                                setConfirmDialogIsOpen(false);
                              },
                            },
                          );
                        },
                        onClose: () => {
                          setConfirmDialogIsOpen(false);
                        },
                        confirmTextBtn: "SI",
                        cancelTextBtn: "NO",
                      });
                    }}
                  >
                    {esTraslado ? "Iniciar Traslado" : "Iniciar Instalación"}
                  </Button>
                </Grid>
              </Grid>
            )}
          </Grid>
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
            <Tab label="DETALLE INSTALACIÓN" value={2} {...a11yProps(2)} />
            <Tab label="INFORMACIÓN CLIENTE" value={3} {...a11yProps(3)} />
            <Tab label="MATERIALES" value={4} {...a11yProps(4)} />
            {esTraslado && <Tab label="FOTOS" value={5} {...a11yProps(5)} />}
          </FormTabsOnly>
        </>
      }
    >
      {/* //* tabs content */}
      {/* ===================== ORDEN TRABAJO ===================== */}
      <CustomTabPanel index={valueTab} value={1}>
        <OTInstalacionTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
          esTraslado={esTraslado}
          observacionTraslado={
            (ordentrabajo as any)?.observaciones?.observacion_traslado ||
            (ordentrabajo as any)?.agendamiento_data?.observaciones?.observacion_traslado ||
            ""
          }
          observacionRecoordinar={
            (ordentrabajo as any)?.observaciones?.observacion_recoordinar ||
            (ordentrabajo as any)?.agendamiento_data?.observaciones?.observacion_recoordinar ||
            ""
          }
        />
      </CustomTabPanel>

      {/* ===================== DETALLES DE INSTALACIÓN ===================== */}
      <CustomTabPanel index={valueTab} value={2}>
        <OTDetalleInstallTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
          coords={ordentrabajo?.agendamiento_data?.coordenadas || ""}
          ordenTrabajo={ordentrabajo!}
          isOnlyView={true}
          canDragMarker
          canRuler
        />
      </CustomTabPanel>

      {/* ===================== DETALLES CLIENTE ===================== */}
      <CustomTabPanel index={valueTab} value={3}>
        <OTDetalleClienteInstallTecnicoFormTab
          form={form}
          errors={errors}
          shrink={shrink}
        />
      </CustomTabPanel>

      {/* ===================== MATERIALES ===================== */}
      <CustomTabPanel index={valueTab} value={4}>
        <OTMaterialesInstallTecnicoFormTab
          form={form}
          ordenTrabajo={ordentrabajo!}
          optionsONT={optionsONT}
          isloadingUbProducto={isloadingUbProducto}
        />
        {/* Otros conceptos + puntos de red del TRASLADO (catálogo de traslados).
            Solo traslados: instalaciones no cambian. */}
        {esTraslado && (
          <Grid {...gridSizeMdLg12} item sx={{ mt: 3 }}>
            <ConceptosTrasladoSection
              conceptos={conceptosTraslado}
              onChangeConceptos={setConceptosTraslado}
              puntosRed={puntosRedTraslado}
              onChangePuntosRed={setPuntosRedTraslado}
              readOnly={isCorrentingData}
              ubicacionFlota={(ordentrabajo as any)?.flota_data?.ubicacion}
              onUploadFoto={isCorrentingData ? undefined : subirFotoEvidenciaTraslado}
              aprobacion={aprobacionTraslado}
              despuesDePuntosRed={
                (tieneFibraPlanaTraslado || excedenteFibraTraslado) && (
                  <ExcedenteFibraTraslado
                    idOrdenTrabajo={ordentrabajo?.id_orden_trabajo}
                    excedente={excedenteFibraTraslado}
                    modo="tecnico"
                    tieneFibra={tieneFibraPlanaTraslado}
                    metrosUtilizados={tieneFibraPlanaTraslado ? metrosFibraPlanaTraslado : null}
                    bloqueado={isCorrentingData}
                    onDirtyChange={setExcedenteFibraDirty}
                    onGuardado={persistirMaterialesTraslado}
                  />
                )
              }
              subtitle={
                trasladoIniciado(ordentrabajo)
                  ? "El traslado ya inició: los conceptos que agregues o cambies quedarán pendientes de aprobación por Activaciones antes de poder finalizar."
                  : "Agrega los conceptos/equipos entregados en el traslado y elige la serie de cada uno. Activaciones los revisará al gestionar."
              }
              footer={
                !isCorrentingData && (
                  <>
                    {!conceptosTrasladoDirty && (conceptosTraslado.length > 0 || puntosRedTraslado.length > 0) && (
                      <Typography variant="caption" color="success.main">
                        ✓ Guardado
                      </Typography>
                    )}
                    <LoadingButton
                      variant="contained"
                      color="secondary"
                      loading={guardandoConceptosTraslado}
                      disabled={!conceptosTrasladoDirty}
                      onClick={guardarConceptosTraslado}
                    >
                      Guardar conceptos del traslado
                    </LoadingButton>
                  </>
                )
              }
            />
          </Grid>
        )}
      </CustomTabPanel>

      {esTraslado && (
        <CustomTabPanel index={valueTab} value={5}>
          <FotosTrasladoTab ordenTrabajo={ordentrabajo} onRefresh={refreshData} />
        </CustomTabPanel>
      )}

      {/* =================== DIALOGS =================== */}
      <RejectInstalacionAsigTecModal
        open={openRejectModal}
        setOpen={setOpenRejectModal}
        idOrdenTrabajo={ordentrabajo?.id_orden_trabajo!}
        observacionesOrdenTrabajo={ordentrabajo?.observaciones}
        ordentrabajo={ordentrabajo}
      />

      <IniciarTrasladoFotosModal
        open={openIniciarTraslado}
        onClose={() => setOpenIniciarTraslado(false)}
        onSuccess={() => refreshData()}
        ordenTrabajo={ordentrabajo}
        location={iniciarLocationTraslado}
        username={currentUser?.username}
      />
      <FinalizarTrasladoFotosModal
        open={openFinalizarTraslado}
        onClose={() => setOpenFinalizarTraslado(false)}
        onSuccess={() => {
          refreshData();
          navigate(returnUrlInstalacionesTecnicoPage);
        }}
        ordenTrabajo={ordentrabajo}
      />

    </TabsFormBoxScene>
  );
};

export default SaveOrdenTrabajoAsignadaTec;
